// extracted by mini-css-extract-plugin
export default {"chart__title":"stylesBase_chart__title__lA0yL"};